import React, { useState, useEffect, useRef } from 'react';

import {

MessageCircle, X, Send, Cpu, Code, Briefcase,

GraduationCap, Mail, Linkedin, Github, Phone, MapPin, Database, Cloud, Calendar, Menu, ExternalLink, Info

} from 'lucide-react';

import './App.css';

import RoleMatcher from './components/RoleMatcher';



// Importing Visual Components

import TechArchitecture from './components/TechArchitecture';

import CodeReviewer from './components/CodeReviewer';



// Importing the local video file

import characterVideo from './Realistic_Character_Video_Generation.mp4';



function App() {

const [input, setInput] = useState('');

const [isTyping, setIsTyping] = useState(false);

const [isOpen, setIsOpen] = useState(false); // AI Side Panel State

const [isMenuOpen, setIsMenuOpen] = useState(false); // Mobile Menu State

const chatEndRef = useRef(null);



// Initial greeting for the AI

const initialMessages = [

{ role: 'ai', text: "Hi! I'm Anuhya's AI assistant. Ask me about her work, or click 'Workflow' on any project to see a live analysis." }

];



// State for conversation history

const [messages, setMessages] = useState(initialMessages);



// State for AI Visual Insights

const [vizData, setVizData] = useState({ type: null, activeId: null, lines: [] });



// NEW: State for Dynamic GitHub Projects

const [projects, setProjects] = useState([]);



// --- NEW: Fetch GitHub Projects from Backend ---

useEffect(() => {

const fetchProjects = async () => {

try {

const response = await fetch('https://sorry-fayth-self-employee-907f0163.koyeb.app/api/github-projects');

const data = await response.json();

setProjects(data);

} catch (err) {

console.error("Error loading dynamic projects:", err);

}

};

fetchProjects();

}, []);



// --- Reset Chat when Sidebar is closed ---

useEffect(() => {

if (!isOpen) {

const timer = setTimeout(() => {

setMessages(initialMessages);

setVizData({ type: null, activeId: null, lines: [] });

}, 400);

return () => clearTimeout(timer);

}

}, [isOpen]);



// Auto-scroll to bottom of AI chat

useEffect(() => {

chatEndRef.current?.scrollIntoView({ behavior: "smooth" });

}, [messages, isTyping]);



// General AI Chat Logic

const handleAskAI = async (overrideInput = null) => {

const query = overrideInput || input;

if (!query) return;



// Add User Message to History

setMessages(prev => [...prev, { role: 'user', text: query }]);

setInput('');

setIsTyping(true);



const lowerInput = query.toLowerCase();

if (lowerInput.includes('architecture') || lowerInput.includes('design') || lowerInput.includes('system')) {

setVizData({ type: 'arch', activeId: 'backend' });

} else if (lowerInput.includes('code') || lowerInput.includes('snippet') || lowerInput.includes('react')) {

setVizData({ type: 'code', lines: [3, 4, 5, 6, 7] });

}



try {

const response = await fetch('https://sorry-fayth-self-employee-907f0163.koyeb.app/api/chat', {

method: 'POST',

headers: { 'Content-Type': 'application/json' },

body: JSON.stringify({ message: query }),

});

const data = await response.json();


// Add AI Response to History

setMessages(prev => [...prev, { role: 'ai', text: data.reply }]);

} catch (error) {

setMessages(prev => [...prev, { role: 'ai', text: "I'm sorry, I'm having trouble connecting to the server. Please try again later." }]);

} finally {

setIsTyping(false);

}

};



// NEW: Project Workflow Deep Dive (GitHub Integration)

const handleProjectDeepDive = async (repoName) => {

setIsOpen(true);

const query = `Explain the workflow for the ${repoName} project.`;

handleAskAI(query);

setVizData({ type: 'arch', activeId: 'api' }); // Show architecture for the workflow

};



const toggleMenu = () => setIsMenuOpen(!isMenuOpen);



return (

<div className="portfolio-container">

{/* --- NAVIGATION --- */}

<nav className="navbar">

<div className="logo">ANUHYA<span>.</span></div>

<div className="menu-icon" onClick={toggleMenu}>

{isMenuOpen ? <X size={28} /> : <Menu size={28} />}

</div>

<div className={`links ${isMenuOpen ? 'nav-active' : ''}`}>

<div className="mobile-close-btn" onClick={() => setIsMenuOpen(false)}>

<X size={32} />

</div>

<a href="#projects" onClick={() => setIsMenuOpen(false)}>Projects</a>

<a href="#experience" onClick={() => setIsMenuOpen(false)}>Experience</a>

<a href="#skills" onClick={() => setIsMenuOpen(false)}>Skills</a>

<a href="#schedule" onClick={() => setIsMenuOpen(false)}>Schedule</a>

<a href="#education" onClick={() => setIsMenuOpen(false)}>Education</a>

<a href="mailto:paturuanuhya@gmail.com" className="contact-btn">Hire Me</a>

</div>

</nav>



{/* --- HERO SECTION --- */}

<section className="hero-section">

<div className="hero-container">

<div className="hero-content">

<h1>Anuhya <span>Paturu</span></h1>

<p>AI Engineer & Full Stack Developer with an M.S. in Computer Science and 3+ years of experience architecting production-grade LLM workflows, RAG systems, and autonomous, self-healing AIOps platforms. Proven track record optimizing infrastructure uptime, processing large-scale datasets, and shipping reactive full-stack web applications (React, Node.js, FastAPI, .NET) serving 50K+ monthly active users. 
Explore my technical ecosystem below, deep-dive into live project repository workflows, or open the command terminal to interface directly with my interactive AI Digital Twin.</p>

<div className="hero-action-area">

<a href="#schedule" className="schedule-cta"><Calendar size={20} /> Schedule Interview</a>

<div className="social-links">

<a href="https://github.com/AnuhyaPaturu" target="_blank" rel="noreferrer"><Github size={24} /></a>

<a href="https://www.linkedin.com/in/anuhya-paturu-574513287" target="_blank" rel="noreferrer"><Linkedin size={24} /></a>

</div>

</div>

<div className="contact-bar">

<a href="mailto:paturuanuhya@gmail.com"><Mail size={18}/> paturuanuhya@gmail.com</a>

<a href="tel:+15624465186"><Phone size={18}/> +1 562-446-5186</a>

<span><MapPin size={18}/> United States</span>

</div>

</div>

<div className="hero-character-wrapper-small">

<div className="character-main-small">

<video className="character-video-refined" autoPlay loop muted playsInline>

<source src={characterVideo} type="video/mp4" />

</video>

</div>

<div className="character-glow-orb"></div>

</div>

</div>

</section>




{/* --- PROJECTS GALLERY SECTION --- */}

<section id="projects" className="section">

<h2 className="section-title"><Code size={28} /> Technical Projects</h2>

<div className="projects-bento-grid">

{projects.map((proj) => (

<div key={proj.repo} className="project-bento-card">

<div className="project-card-inner">

<div className="project-card-header">

<div className="tech-stack-icons">

<Cpu size={16} className="tech-icon-pulse" />

<Database size={16} />

</div>

<a href={proj.url} target="_blank" rel="noreferrer" className="github-link">

<Github size={20} />

</a>

</div>


<div className="project-card-content">

<h3>{proj.title}</h3>

<p>{proj.desc}</p>

</div>



<div className="project-card-footer">

<div className="tech-tags-wrapper">

{proj.tech.map(t => <span key={t} className="tech-tag-mini">{t}</span>)}

</div>

<button className="workflow-btn" onClick={() => handleProjectDeepDive(proj.repo)}>

<Info size={14} /> Workflow

</button>

</div>

</div>

</div>

))}

</div>

</section>



{/* --- EXPERIENCE SECTION --- */}
      <section id="experience" className="section bg-alt">
        <h2 className="section-title"><Briefcase size={28} /> Professional Experience</h2>
        <div className="timeline">
          
          <div className="timeline-item">
            <div className="time-header">
              <h3>AI Engineer</h3>
              <span className="company">Qualitest | Mar 2026 - Present</span>
            </div>
            <p className="impact-stat">Manual review reduced by 40% | 99.9% Uptime SLA</p>
            <ul>
              <li>Engineered LLM-powered validation pipelines using Azure OpenAI (GPT-4) with few-shot prompt engineering and confidence-threshold gating, automating multimodal dataset labeling at scale reducing manual review by 40% and cutting ML dataset preparation time by 3x[cite: 27].</li>
              <li>Architected a Self-Healing AIOps platform applying unsupervised ML (Isolation Forest, Scikit-learn) for real-time anomaly detection and autonomous remediation achieving 99.9% uptime SLA and reducing incident-driven downtime by 30% across production infrastructure[cite: 28].</li>
              <li>Designed and orchestrated scalable ML data ingestion pipelines (Azure AKS, Azure ML, Apache Kafka) processing TB-scale datasets with 99% data integrity supporting Computer Vision training cycles with automated data validation and drift detection[cite: 29].</li>
              <li>Built a RAG pipeline using Azure OpenAI (GPT-4) and Pinecone vector store to ground LLM responses in domain-specific context, improving labeling accuracy by 23% across TB-scale multimodal sensor data (IMU, Audio, Optics) replacing brittle rule-based classifiers with semantic retrieval[cite: 30].</li>
              <li>Collaborated with ML engineers and data scientists in Agile/Scrum sprints to ship 3+ production-ready AI/ML pipelines, reducing time-to-deployment from research prototype to Azure ML by ~40%[cite: 31].</li>
            </ul>
          </div>

          <div className="timeline-item">
            <div className="time-header">
              <h3>Full Stack Engineer</h3>
              <span className="company">Saayam For All | Aug 2025 - Mar 2026</span>
            </div>
            <p className="impact-stat">Donation conversion increased by 35% | Latency cut by 30%</p>
            <ul>
              <li>Developed full-stack features for a platform serving 50K+ monthly active users using event-driven architecture, increasing donation conversion rates by 35%[cite: 34].</li>
              <li>Built distributed backend services with Node.js and PostgreSQL to enable real-time donation tracking and campaign management, processing 5K+ transactions daily and improving system efficiency by 35%[cite: 35].</li>
              <li>Optimized PostgreSQL indexing and implemented distributed Redis caching, reducing system latency by 30% during high-traffic bursts of 5K+ concurrent transactions[cite: 36].</li>
              <li>Delivered low-latency REST APIs with JWT authentication and RBAC, achieving sub-200ms response times and zero auth-related security incidents across 5K+ daily transactions[cite: 38].</li>
            </ul>
          </div>

          <div className="timeline-item">
            <div className="time-header">
              <h3>Full Stack Engineer</h3>
              <span className="company">Cognizant Technology Solutions | Feb 2021 - July 2023</span>
            </div>
            <p className="impact-stat">Load times reduced by 30-40% | Reporting efficiency improved by 35%</p>
            <ul>
              <li>Spearheaded modernization of the CXO Dashboard using .NET, Angular, and SQL Server, reducing page load times by 30-40% and backend data retrieval times by 25% through query refactoring, stack trace analysis, and optimized PostgreSQL database schemas[cite: 43].</li>
              <li>Built a Portfolio Management System with React.js, Flask, and GraphQL, enabling real-time financial tracking and improving reporting efficiency by 35%[cite: 44].</li>
              <li>Migrated legacy SQL stored procedures to scalable data models and built reusable Angular components, reducing development effort by 20% and cutting production bug reports by 30%[cite: 45].</li>
              <li>Engineered JWT and OAuth 2.0 role-based authentication and integrated RESTful and GraphQL APIs, reducing client-side data fetch times by 25%[cite: 46].</li>
              <li>Partnered with QA engineers and release managers to close 15+ testing gaps across 3 release cycles, reducing post-deployment defects by 25% and cutting rollback incidents by 40%[cite: 47].</li>
            </ul>
          </div>

        </div>
      </section>


{/* --- SKILLS SECTION --- */}
<section id="skills" className="section">
  <h2 className="section-title"><Cpu size={28} /> Technical Ecosystem</h2>
  <div className="skills-container">
    
    {/* AI/ML & LLMs */}
    <div className="skill-category">
      <h4><Cpu size={18}/> AI/ML & LLMs</h4>
      <div className="skill-tags">
        {[
          "GPT-4", "OpenAI API", "Azure OpenAI", "RAG", "LLM Agents", 
          "LangChain", "Hugging Face", "RLHF", "Fine-Tuning (LoRA)", 
          "PyTorch", "TensorFlow", "Scikit-learn", "Computer Vision", "NLP"
        ].map(s => <span className="tag" key={s}>{s}</span>)}
      </div>
    </div>

    {/* MLOps & Infrastructure */}
    <div className="skill-category">
      <h4><Cloud size={18}/> MLOps & Infrastructure</h4>
      <div className="skill-tags">
        {[
          "Azure ML", "AWS SageMaker", "GCP Vertex AI", "MLflow", 
          "Docker", "Kubernetes (AKS/GKE)", "Helm", "Terraform", "Ansible"
        ].map(s => <span className="tag" key={s}>{s}</span>)}
      </div>
    </div>

    {/* Frameworks & Languages */}
    <div className="skill-category">
      <h4><Code size={18}/> Frameworks & Languages</h4>
      <div className="skill-tags">
        {[
          "Python", "Java", "TypeScript", "JavaScript", "C++", "C#",
          "React.js", "Angular", "Vue.js", "FastAPI", "Node.js", 
          "Express.js", "Flask", "Django", "Spring Boot", ".NET Core"
        ].map(s => <span className="tag" key={s}>{s}</span>)}
      </div>
    </div>

    {/* Data, Security & Pipelines */}
    <div className="skill-category">
      <h4><Database size={18}/> Data, Security & Pipelines</h4>
      <div className="skill-tags">
        {[
          "PostgreSQL", "MongoDB", "Redis", "MySQL", "SQL Server", 
          "Pinecone", "ChromaDB", "FAISS", "Apache Kafka", "RabbitMQ", 
          "GraphQL", "RESTful APIs", "JWT", "OAuth 2.0"
        ].map(s => <span className="tag" key={s}>{s}</span>)}
      </div>
    </div>

  </div>
</section>



{/* --- EDUCATION SECTION --- */}

<section id="education" className="section bg-alt">

<h2 className="section-title"><GraduationCap size={28} /> Education</h2>

<div className="edu-card">

<div className="edu-info">

<h3>Master of Science in Computer Science</h3>

<p className="edu-school">California State University, Long Beach, USA</p>

</div>

<span className="edu-date">Aug 2023 - May 2025</span>

</div>

</section>



{/* --- ROLE MATCHER SECTION --- */}

<section className="section match-section">

<div className="container mx-auto px-4">

<RoleMatcher />

</div>

</section>





{/* --- SCHEDULING SECTION --- */}

<section id="schedule" className="section">

<h2 className="section-title"><Calendar size={28} /> Book an Interview</h2>

<div className="booking-container">

<div className="booking-info">

<h3>Let's discuss more.</h3>

<p>Pick a time for a 30-minute call directly through my calendar synced with my local time.</p>

</div>

<div className="calendar-frame">

<iframe

src="https://calendly.com/paturuanuhya/30min"

width="100%"

height="600"

frameBorder="0"

title="Schedule Appointment"

></iframe>

</div>

</div>

</section>



{/* --- AI SIDEBAR --- */}

<button className={`ai-fab ${isOpen ? 'active' : ''}`} onClick={() => setIsOpen(!isOpen)}>

{isOpen ? <X size={28} /> : <MessageCircle size={28} />}

</button>



<aside className={`ai-sidebar ${isOpen ? 'open' : ''}`}>

<div className="ai-sidebar-header">

<div className="human-persona">

<div className="avatar-wrapper">

<img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=200&h=200" alt="Avatar" className="human-avatar" />

<span className="online-indicator"></span>

</div>

<div className="persona-details">

<h3>Anuhya's Digital Twin</h3>

<p>Professional Assistant</p>

</div>

</div>

<button className="close-sidebar" onClick={() => setIsOpen(false)}><X size={20}/></button>

</div>



<div className="ai-sidebar-body">

{vizData.type && (

<div className="ai-viz-display">

<div className="viz-header">

<span>{vizData.type === 'arch' ? 'Workflow Architecture' : 'Technical Insight'}</span>

<button onClick={() => setVizData({ type: null })}>Close</button>

</div>

{vizData.type === 'arch' && <TechArchitecture activeNode={vizData.activeId} />}

{vizData.type === 'code' && (

<CodeReviewer

code={`// Optimized Data Fetching Hook\nconst useDashboardData = (apiEndpoint) => {\n const [data, setData] = useState(null);\n useEffect(() => {\n fetch(apiEndpoint).then(res => res.json()).then(setData);\n }, [apiEndpoint]);\n return data;\n};`}

highlightLines={vizData.lines}

/>

)}

</div>

)}



<div className="chat-history">

{messages.map((msg, index) => {

const isLatestAI = msg.role === 'ai' && index === messages.length - 1;



return (

<div key={`${index}-${msg.role}`} className={`chat-bubble ${msg.role}`}>

{isLatestAI ? (

<div style={{ display: 'inline' }}>

{msg.text.split(' ').map((word, i) => (

<span

key={i}

className="word-reveal"

style={{ animationDelay: `${i * 0.08}s`, marginRight: '4px' }}

>

{word}

</span>

))}

</div>

) : (

<span style={{ whiteSpace: 'pre-wrap' }}>{msg.text}</span>

)}

</div>

);

})}

{isTyping && (

<div className="chat-bubble ai typing">

<div className="typing-dots"><span></span><span></span><span></span></div>

</div>

)}

<div ref={chatEndRef} />

</div>

</div>



<div className="ai-sidebar-footer">

<div className="input-group">

<input value={input} onChange={(e) => setInput(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && handleAskAI()} placeholder="Ask about her systems..." />

<button onClick={() => handleAskAI()} disabled={isTyping}><Send size={18}/></button>

</div>

</div>

</aside>

</div>

);

}



export default App;

